import { useContext, useEffect, useRef, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';

const DashboardAccordianItem = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);
    const [expanded, setExpanded] = useState(true);
    const divRef = useRef<HTMLDivElement>(null);

    const setStateValue = (dataKey: string, value: string) =>
        dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey, value, errorMessages: [] } });
 

    useEffect(() => {
        // Update individual accordion state based on the global accordion state
        setExpanded(state.data.accordionState === 'EXPANDED');
    }, [state.data.accordionState]);



    return (
        <div className="shadow p-4 rounded-3 h-100 border" id={`panelsStayOpen-${props.reportKey}`}>
            <h3 className="font-20 font-600 mb-3">{props.title}</h3>
            {props.children}
        </div>
    );
};

export default DashboardAccordianItem;
